import styled from 'styled-components';

export const BoardBox = styled.div<{ width: number, height: number }>`
  display: flex;
  flex-wrap: wrap;
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  border: 3px solid #838383;
  border-bottom-color: #fff;
  border-right-color: #fff;
`;